<template>
  <div>
   <p class="main_title">查询记录</p>
    <DatePicker type="daterange" split-panels confirm format="yyyy-MM-dd" :editable="editable" placement="bottom-end" style="width:100%;max-width: 450px;" placeholder="请选择时间范围" v-model="timeZone" @on-clear="timeClear" @on-ok="timeOnChange"></DatePicker>
    <div>
      <br />
    </div>
    <div class="demo-spin-container">
      <Table class="tableBorder" :data="tableData1"  :columns="tableColumns1" size="small" :show-header="showheader"></Table>
      <br />
      <Row>
        <Col span="24">
        <Page :total="pageTotal" :current.sync="pageIndex" @on-change="changePage"></Page>
        </Col>
      </Row>
      <Spin fix v-if="spinShow1"></Spin>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HistoryTable',
  props: { mydata: Object, },
  data() {
    return {
      tableData1: [], //this.mockTableData1(), //tabledata.tabrows,
      tableColumns1: [], //this.mockTableHeader(),
      timeZone: [],
      spinShow1: false,
      showHeaders: [],
      pageTotal: 10,
      showheader: false,
      editable: false,
      pageIndex:1,
    }
  },
  components: {

  },
  inject: ['CreatePage', 'getSliders'],
  methods: {
    mockTableData1(tabrows) {
      //console.log(this.mydata)
      let da = [];
      let items = tabrows //this.mydata.tabrows
      for (var i = 0; i < items.length; i++) {
        da.push({
          fileid: items[i].strdocid,
          filename: items[i].h1,
          readtime: items[i].accesstime,
        })
      }
      //console.log(da)
      return da;
    },
    mockTableHeader(header, headerTitle) {
      var that = this
      let da = [];
      let items = header //this.mydata.header;
      let newHeaders = [];
      this.setHeader(headerTitle);
      for (var i = 0; i < items.length; i++) {
        if (this.showHeaders.indexOf(items[i].key) >= 0) {
          newHeaders.push(items[i])
        }
      }
      // console.log(newHeaders)
      items = newHeaders;
      da.push({
        type: 'index',
        width: 60,
        align: 'center'
      })
      for (var i = 0; i < items.length; i++) {
        if (items[i].key == "filename") {
          da.push({
            title: items[i].title,
            key: items[i].key,
            // width: items[i].width,
            // align: items[i].align,
            // render: (h, params) => {
            //   const row = params.row;
            //   const text = row.filename;
            //   const fileid = row.fileid;
            //   const readtime = row.readtime;
            //   // return h('a', {
            //   //   on: {
            //   //     'click': () => {
            //   //       this.add(fileid, 1);
            //   //     }
            //   //   }
            //   // }, readtime+"查阅了《"+text+"》");
            // }
            render: function(createElement, params) {
              const row = params.row;
              const text = row.filename;
              const fileid = row.fileid;
              const readtime = row.readtime;
              return createElement('div', {}, [
                readtime,
                "查阅了 ",
                createElement('a', {
                  domProps:{
                    innerHTML:``+text+``
                  },
                  on: {
                    'click': () => {
                      that.add(fileid, 1, text,row);
                    }
                  }
                }, text),
              ])
            }
          })

        } else {
          da.push({
            title: items[i].title,
            key: items[i].key,
            // width: items[i].width,
            // align: items[i].align,
          })
        }

      }

      return da;
    },
    setHeader(arrayObj) {
      if (arrayObj == null || arrayObj == undefined || arrayObj.length == 0) {
        this.showHeaders = ['fileid', 'filename']
      } else {
        this.showHeaders = arrayObj
      }

    },
    // formatDate (date) {
    //     const y = date.getFullYear();
    //     let m = date.getMonth() + 1;
    //     m = m < 10 ? '0' + m : m;
    //     let d = date.getDate();
    //     d = d < 10 ? ('0' + d) : d;
    //     return y + '-' + m + '-' + d;
    // },
    changePage(index) {
      // The simulated data is changed directly here, and the actual usage scenario should fetch the data from the server
      //this.tableData1 = this.mockTableData1();
      this.$emit('changepage', index)
    },
    add(fid, orderid, filename,row) {
      this.CreatePage(fid, orderid, filename,row);
    },
    reloadHeaderData(obj) {
      this.tableColumns1 = this.mockTableHeader(obj);
    },
    cityNextSearch() {
      // this.value1 = "1"
      this.spinShow1 = true
      var that = this
      setTimeout(function() {
        that.spinShow1 = false
      }, 1000)
    },
    timeClear(){
      this.$emit('ontimechange')
    },
    timeOnChange() {
      var time = []
      if (this.timeZone[0] !== "") {
        time[0] = this.getFormattedDate(this.timeZone[0])
        time[1] = this.getFormattedDate(this.timeZone[1])
        this.$emit('ontimechange', time)
      }else{
        this.$emit('ontimechange')
      }

      // console.log(this.timeZone)

      // if (this.timeZone[0]!=="") {
      //   //console.log(this.getFormattedDate(this.timeZone[0]) + "-" + this.getFormattedDate(this.timeZone[1]))
      //   this.cityNextSearch()
      // }

    },
    getFormattedDate(date) {
      var year = date.getFullYear();
      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : '0' + month;
      var day = date.getDate().toString();
      day = day.length > 1 ? day : '0' + day;
      return year + '-' + month + '-' + day;
    },
    show(data) {
      //console.log(data.total)
      // this.classId=data.classid
      this.pageIndex=data.index
      this.tableName = data.tabname
      this.pageTotal = data.total
      this.tableData1 = this.mockTableData1(data.tabrows)
      this.tableColumns1 = this.mockTableHeader(data.header, ['filename'])
      //在路由切换时存在已分屏的情况，在已分屏情况下需要判断是否处于分屏在渲染table的header

      // if (this.sliders.length > 0) {
      //   this.tableColumns1 = this.mockTableHeader(data.header, ['h1'])
      // } else {
      //   this.tableColumns1 = this.mockTableHeader(data.header, '')
      // }

      this.$nextTick(() => {

      })

    },
  },
  watch: {
    sliders: function() {
      if (this.sliders.length == 0) {
        this.reloadHeaderData([]);
      } else if (this.sliders.length > 0) {
        this.reloadHeaderData(['filename']);
      }
    },
  },
}

</script>
<style scoped>
.demo-spin-container {
  display: inherit;
  width: auto;
  height: auto;
  position: relative;
  /* border: 1px solid #eee;*/
}
.tableBorder {
  /*border: 1px solid #dcdee2;*/
  border-bottom: none;

}
.tableBorder > .ivu-table >.ivu-table-overflowX{
  overflow-x: hidden;
}
.main_title{
height: 20px;
font-size: 20px;
font-family: Source Han Sans CN;
font-weight: bold;
color: #2D2F33;
margin-bottom: 30px;
padding-left: 10px;
}
</style>
